import script from "./SelectTipo.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectTipo.vue?vue&type=script&setup=true&lang=js"

import "./SelectTipo.vue?vue&type=style&index=0&id=31992a85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31992a85"]])

export default __exports__